import React from "react";
import { Typography, Box } from "@mui/material";

export default function About() {
    return (
        <Box sx={{
                py: 8,
                justifyContent: "space-between",
                textAlign: "center",
            }}>
            
            <Typography variant="h4" gutterBottom>
                About Me
            </Typography>
            <Typography color="text.secondary">
                Curiosity has always been one of the first words that people in my life use to describe me. As an aircraft mechanic in the Navy, my dad has always emphasized asking any questions that come to mind to learn about the world around me, especially how things work. This has fueled my curiosity about everything in my life, but as I've grown older, I've developed a love for learning everything I can about technology, especially.
            </Typography>
            <p></p>
            
            <Typography color="text.secondary">
                Now, as a student in Electrical and Computer Engineering with 10 years of experience in robotics and automotive design/manufacturing, these experiences have done nothing but fuel my natural curiosity. The more I learn about what interests me, the more I want to learn.
            </Typography>
            <p></p>

            <Typography color="text.secondary">
                I'm currently seeking jobs that will further my career in electrical and computer engineering, while utilizing the engineering skills I've developed over the years!
            </Typography>

        </Box>
    );
}
